import React from 'react'
import styled from 'styled-components/macro'
import { Link } from 'react-router-dom'
import { injectIntl, intlShape } from '@dragonraider5/react-intl'
import TriodosLogo from '../../../components/TriodosLogo'
import Header, { HeaderCentered, HeaderAside } from '../../../components/Header'
import AppHeaderLoginButton from './AppHeaderLoginButton'
import LogoutButton from './LogoutButtons'
import { MenuItemLink } from '../../../components/Menu/MenuItem'
import messages from './messages'
import { APPLICATIONS_PATH } from '../../MainRoutes/constants'

export const LogoLink = styled(Link)`
  display: inline-block;
  line-height: 0;
`

export function AppHeader({ intl }) {
  return (
    <Header>
      <HeaderAside side='left' />
      <HeaderCentered>
        <LogoLink to={APPLICATIONS_PATH} title={intl.formatMessage(messages.rootLinkTitle)}>
          <TriodosLogo />
        </LogoLink>
      </HeaderCentered>
      <HeaderAside side='right'>
        <AppHeaderLoginButton menuProps={{ align: 'right', offset: 15 }}>
          <MenuItemLink to={APPLICATIONS_PATH} as={Link}>Mis solicitudes</MenuItemLink>
          <MenuItemLink to='/perfil' as={Link}>Mi perfil</MenuItemLink>
          <LogoutButton />
        </AppHeaderLoginButton>
      </HeaderAside>
    </Header>
  )
}

AppHeader.propTypes = {
  intl: intlShape.isRequired
}

export default injectIntl(AppHeader)
